<template>
  <div v-if="loading.Data" class="d-flex flex-column h-100">
    <spinner-loading></spinner-loading>
  </div>
  <div v-else id="dashboard-column-chart" class="py-2 h-100">
    <div class="pl-3">
      <div class="card-content-title-wrp d-flex justify-content-between">
        <div>
          <div class="content-name">
            {{
              renderData.jsonOverride.Left_Title
                ? renderData.jsonOverride.Left_Title
                : config.config.left_title
            }}
          </div>
          <div
            class="content-value"
            v-if="
              renderData.jsonOverride.Button_Left_Title ||
              config.config.button_left_title
            "
          >
            <span>
              {{
                renderData.jsonOverride.Button_Left_Title
                  ? renderData.jsonOverride.Button_Left_Title
                  : config.config.button_left_title
              }}</span
            >
            <span> คำตอบ</span>
          </div>
        </div>
        <div class="">
          <div
            class="content-type pr-2 d-flex justify-content-end"
            v-if="
              renderData.jsonOverride.Right_Title || config.config.right_title
            "
          >
            <div class="d-flex justify-content-between content-type-wrp">
              <div
                :class="
                  layoutData.module_name == 'SurveyDashboard'
                    ? 'border-type'
                    : ''
                "
              >
                Type :
              </div>
              <div class="d-flex ml-2">
                <div class="mr-1 icon-type-svg">
                  <component
                    :is="
                      resovleIcon(
                        renderData.jsonOverride.Right_Title
                          ? renderData.jsonOverride.Right_Title
                          : config.config.right_title
                      )
                    "
                    class="mr-2"
                  />
                </div>
                <div>
                  {{
                    renderData.jsonOverride.Right_Title
                      ? renderData.jsonOverride.Right_Title
                      : config.config.right_title
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-row>
        <b-col>
          <div class="content-title">{{ config.config.title }}</div>
          <v-chart
            ref="chartBar"
            class="chart-customer"
            :option="option"
            autoresize
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  watch,
  reactive,
  onMounted,
  getCurrentInstance,
  onBeforeMount,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  GridComponent,
  VisualMapComponent,
  DatasetComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  GridComponent,
  VisualMapComponent,
  BarChart,
  DatasetComponent,
]);

import SingleChoiceSvg from "@/@core/components/svg/question-modal/SingleChoice.vue";
import MultipleChoiceSvg from "@/@core/components/svg/survey/MultipleChoice.vue";
import TextAreaSvg from "@/@core/components/svg/survey/TextArea.vue";
import DateSvg from "@/@core/components/svg/survey/Date.vue";
import DropdownSvg from "@/@core/components/svg/survey/Dropdown.vue";

import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default {
  props: {
    config: { default: {} },
    layoutData: { default: {} },
    data: { default: {} },
  },
  components: {
    VChart,
    SingleChoiceSvg,
    MultipleChoiceSvg,
    TextAreaSvg,
    DateSvg,
    DropdownSvg,
  },
  setup(props) {
    const { fetchQueryDataDashboard } = surveyModel();

    const { openDefaultErrorModal } = useValidationModal();

    const loading = reactive({
      Data: false,
    });

    const option = reactive({
      color: ["#FFD200"], // Global palette chart
      grid: {
        bottom: "15%",
      },
      yAxis: [
        {
          type: "category",
          data: [],
          label: {
            show: true,
            position: "insideLeft",
          },
          axisTick: {
            show: false,
          },
          inverse: true,
          axisLine: {
            show: false,
          },
          position: "top",
          axisLabel: {
            color: "#000000",
            inside: true,
          },
          z: 10,
        },
        {
          data: [],
          inverse: true,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#000000",
            inside: true,
          },
          z: 10,
        },
      ],
      xAxis: {
        type: "value",
        splitLine: { show: false },
        axisLabel: {
          show: false,
        },
        // max: 26,

        // inverse: true,
      },

      series: [
        {
          data: [],
          type: "bar",
          itemStyle: {
            borderRadius: 5,
          },
          barWidth: "90%",
          showBackground: true,
          backgroundStyle: {
            color: "rgba(250, 250, 250)",
            borderRadius: 5,
            padding: ["10%", "40%", 0, "40%"],
          },
        },
      ],
    });

    const formData = reactive({
      groupId: "",
      moduleName: "",
    });

    const renderData = reactive({
      data: [],
      legend: [],
      jsonOverride: null,
    });

    const MODULENAME = reactive({
      SURVEY: "SurveyDashboard",
    });

    const resolveChartModule = (moduleName, GroupId) => {
      switch (moduleName) {
        case MODULENAME.SURVEY:
          fetchDashboradSurveyDetail(GroupId);
          return;
      }
    };

    const fetchDashboradSurveyDetail = (GoupId) => {
      loading.Data = true;
      const payload = {
        CardId: props.config.id,
        Survey_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataDashboard)
        .then((response) => {
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);

          response.data.list.map((o) => {
            option.yAxis[0].data.push(o.name);
            option.yAxis[1].data.push(o.value);
            // option.series[0].data.push(o.value);
            option.series[0].data.push({
              value: o.value,
              itemStyle: {
                color: o.name == "Other Answers" ? "#C6C6C6" : "#FFD200",
              },
            });
          });
        })
        .catch((error) => {
          console.log(error);
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const resovleIcon = (iconName) => {
      switch (iconName) {
        case "Single Choice":
          return "SingleChoiceSvg";
        case "Multiple Choice":
          return "MultipleChoiceSvg";
        case "Dropdown":
          return "DropdownSvg";
        case "Date":
          return "DateSvg";
        case "Text Area":
          return "TextAreaSvg";
      }
    };

    onBeforeMount(() => {
      formData.groupId = parseInt(router.currentRoute.params.ref);
      formData.moduleName = props.layoutData.module_name;

      resolveChartModule(formData.moduleName, formData.groupId);
    });

    return { loading, option, renderData, resovleIcon };
  },
};
</script>

<style>
#dashboard-column-chart .icon-type-svg > svg {
  fill: #a2a2a2 !important;
  stroke: #a2a2a2 !important;
  width: 15px !important;
  height: 15px !important;
  margin-bottom: 1px;
}
</style>

<style scoped>
#dashboard-column-chart .chart-customer {
  width: 100%;
  height: 300px;
}

/* .quiz-dashborad-wrp {
  border-right: 1px solid #0000000d;
} */

#dashboard-column-chart .card-content-title-wrp {
  min-height: 70px;
}

#dashboard-column-chart .content-name {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}

#dashboard-column-chart .content-value {
  font-size: 18px;
  padding-left: 16px;
  color: #707070;
}

#dashboard-column-chart .content-title {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
  padding-left: 16px;
}

#dashboard-column-chart .content-type {
  font-size: 18px;
  color: #707070;
}

#dashboard-column-chart .content-type-wrp {
  width: 163px;
}

#dashboard-column-chart .legend-wrp {
  position: absolute;
  bottom: 0;
  right: 50%;
  display: flex;
}

#dashboard-column-chart .legend-radius-color {
  margin-right: 10px;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}

#dashboard-column-chart .legend-title {
  font-size: 18px;
  color: #000;
}

#dashboard-column-chart .border-type {
  border-left: 1.5px solid #a2a2a2;
  height: 30px;
  padding-left: 10px;
}
</style>